import LegalLayout from "./LegalLayout";
import ComingSoon from "./ComingSoon";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" kicker="Legal">
      <ComingSoon
        blurb="Our terms of service are being polished by the legal team. Check back shortly."
        testid="legal-terms-coming-soon"
      />
    </LegalLayout>
  );
}
